import * as React from 'react';
import * as styles from './styles.scss';
import { getDocumentSurfaceStyle, isPanning } from '../viewstate';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import useTimeStreamDocumentSurfaceViewState from '../hooks/useTimeStreamDocumentSurfaceViewState';
import TimeStreamAssetViews from './TimeStreamAssetViews';
import { isCurrentCultureRightToLeft } from 'owa-localize';

export default observer(function TimeStreamDocumentSurface() {
    const { onKeyDown } = useTimeStreamDocumentSurfaceViewState();
    const className = classNames(styles.documentSurface, {
        [styles.documentSurfaceWhenPanning]: isPanning(),
        [styles.rtl]: isCurrentCultureRightToLeft(),
    });
    return (
        <div onKeyDown={onKeyDown} className={className} style={getDocumentSurfaceStyle()}>
            <TimeStreamAssetViews />
        </div>
    );
});
